const emailValidator = (value) => /^[^@]+@[^@]+\.[^@]+$/i.test(value)

const isTrueValidator = (value) => value === true

const nameValidator = (value) => /^[ a-zA-Z\-’']+$/i.test(value)

const npnValidator = (value) => /^[1-9][\d]{0,9}$/i.test(value)

const presenceValidator = (value) =>
  value !== undefined && value !== null && `${value}`.trim().length !== 0

export { emailValidator, isTrueValidator, nameValidator, npnValidator, presenceValidator }
